class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8.5 13c-1.808 0-3.166-1.149-3.723-3H9.5V9H4.566A7.639 7.639 0 0 1 4.5 8c0-.165.005-.332.013-.5H9.5v-1H4.619C4.922 4.676 5.905 3 8.5 3c1.927 0 2.766.823 3.564 2.245l.872-.49C12.133 3.325 11.039 2 8.5 2c-3.178 0-5 2.187-5 6 0 3.533 2.056 6 5 6 2.539 0 3.633-1.324 4.436-2.755l-.872-.49C11.266 12.177 10.427 13 8.5 13Z"></path></svg>';
  }
}
const e = "pi-currency-euro";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
